module.exports = __webpack_public_path__ + "static/media/galeryGrass4.a3b2b458.jpg";